import createActions from 'utils/redux/createActions'

export default createActions([
	'COMMENTWIZARD_SHOW'
  , 'COMMENTWIZARD_HIDE'
])



// WEBPACK FOOTER //
// ./src/actions/commentWizard.js